import { Navigate, Outlet } from "react-router-dom";
import { useRoles } from "./useRoles";

/** Keeps clients inside the dashboard: any expert-only route redirects them there. */
export default function RequireExpert() {
  const { isClient } = useRoles();
  return isClient ? <Navigate to="/dashboard" replace /> : <Outlet />;
}
